import Vue from 'vue'
import { store } from '_/vuex/store'
import { mapGetters } from 'vuex'
import advancedSearchFactory from '_/vuex/modules/advancedSearch'
import _ from 'lodash'
const Modal = Vue.component(
  'Modal',
  require('_/components/UserInterface/Modal/Modal.vue').default
)
const Search = Vue.component(
  'Search',
  require('_/components/Admin/Search/Search.vue').default
)

const AdvancedSearch = Vue.component(
  'AdvancedSearch',
  require('_/components/UserInterface/Sidebar/AdminSidebar/AdvancedSearch/AdvancedSearch.vue')
    .default
)

export default {
  /*
   * Define props
   *
   * @type  {Object}
   */
  props: {
    relatedTableNames: {
      type: Array,
      required: true,
    },
  },

  /**
   * Set the data property
   *
   * @return  {object}
   */
  data() {
    return {
      /**
       * Advanced search fields
       *
       * @type {array}
       */
      fields: [],

      /**
       * Selected references
       *
       * @type  {array}
       */
      selectedReferences: [],
    }
  },

  /**
   * Set the components
   *
   * @return  {object}
   */
  components: {
    AdvancedSearch,
    Modal,
    Search,
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    ...mapGetters({
      photonModule: 'photonModule/photonModule',
    }),

    /**
     * Advanced Search module getter
     *
     * @return  {object}
     */
    advancedSearch() {
      const getterName = `${this.vuexModuleName}/${this.vuexModuleName}`

      return store.getters[getterName]
    },

    /**
     * Returns the number of selected references
     *
     * @returns integer
     */
    selectedReferencesCount() {
      return this.selectedReferences.length
    },

    /**
     * vuexModuleName getter
     *
     * @return  {string}
     */
    vuexModuleName() {
      return `${
        this.relatedTableNames[0]
      }-reference-advanced-search-${Date.now()}`
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Toggles the reference link
     *
     * @param   {object}  entry
     * @return  {void}
     */
    toggleLinkReference({ entry } = {}) {
      const existingReferenceIndex = _.findIndex(
        this.selectedReferences,
        selectedReference => {
          return (
            selectedReference.system.id === entry.system.id &&
            selectedReference.system.module.table_name ===
              entry.system.module.table_name
          )
        }
      )

      if (existingReferenceIndex > -1) {
        return this.clearReference(entry)
      }

      return this.linkReference(entry)
    },

    /**
     * Removes a selected single reference
     *
     * @param   {integer}  reference
     * @return  {void}
     */
    clearReference(reference) {
      const selectedReferencesIndex = _.findIndex(
        this.selectedReferences,
        selectedReference => {
          return (
            selectedReference.system.id === reference.system.id &&
            selectedReference.system.module.table_name ===
              reference.system.module.table_name
          )
        }
      )

      this.selectedReferences.splice(selectedReferencesIndex, 1)
    },

    /**
     * Links a reference and hides the reference panel, if opened.
     *
     * @param   {object}  reference
     * @return  {void}
     */
    linkReference(reference = null) {
      if (!reference) {
        return
      }

      const existingReferenceIndex = _.findIndex(
        this.selectedReferences,
        selectedReference => {
          return (
            _.get(selectedReference, 'system.id', null) ===
              _.get(reference, 'system.id', null) &&
            _.get(selectedReference, 'system.module.table_name', null) ===
              _.get(reference, 'system.module.table_name', null)
          )
        }
      )

      if (existingReferenceIndex > -1) {
        this.selectedReferences[existingReferenceIndex] = _.cloneDeep(reference)
      } else {
        this.selectedReferences.push(reference)
      }
    },

    /**
     * Emits the closeReferenceSelector event
     *
     * @return  {void}
     */
    closeReferenceSelector() {
      this.$emit('closeReferenceSelector')
    },

    /**
     * Emits the closeAndInsertReferences event
     *
     * @return  {void}
     */
    closeAndInsertReferences() {
      this.$emit('closeAndInsertReferences', this.selectedReferences)
    },
  },

  /**
   * Set the created hook
   *
   * @return  {void}
   */
  created() {
    if (!_.has(store.state, this.vuexModuleName)) {
      store.registerModule(
        this.vuexModuleName,
        advancedSearchFactory(this.vuexModuleName)
      )
    }
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted() {
    const payload = this.advancedSearch.payload
    store.dispatch(`${this.vuexModuleName}/filterModuleEntries`, {
      moduleTableName: this.relatedTableNames,
      payload,
    })
  },
}
